export const parseSseChunk = (buffer) => {
  const parts = buffer.split("\n\n");
  const rest = parts.pop();
  const events = [];
  for (const part of parts) {
    const line = part.trim();
    if (!line.startsWith("data:")) continue;
    const data = line.slice(5).trim();
    if (data === "[DONE]") continue;
    try {
      events.push(JSON.parse(data));
    } catch (err) {
      console.warn("Skipping malformed SSE chunk", data);
    }
  }
  return { events, rest };
};

export const streamPitch = async (url, company, onEvent) => {
  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ company }),
  });
  if (!res.ok || !res.body) throw new Error(`Pitch request failed (${res.status})`);
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const { events, rest } = parseSseChunk(buf);
    buf = rest;
    events.forEach(onEvent);
  }
};
